module.exports = __webpack_public_path__ + "img/player202509.c1f8b13f.png";